import { ApiError } from '../errors/api-error.js';

export class IntegrationExportService {
    constructor(api) { this.api = api; }

    async types() { return this._wrap(() => this.api.types(), 'Failed to list types'); }
    async create(input, idempotencyKey) { return this._wrap(() => this.api.create(input, idempotencyKey), 'Failed to start export'); }
    async list(params) { return this._wrap(() => this.api.list(params), 'Failed to list exports'); }
    async transfers(params) { return this._wrap(() => this.api.transfers(params), 'Failed to list transfers'); }
    async get(id) { return this._wrap(() => this.api.get(id), 'Failed to load export'); }
    async cancel(id) { return this._wrap(() => this.api.cancel(id), 'Failed to cancel export'); }
    async download(id) {
        try {
            const response = await this.api.download(id);
            return { success: true, data: response.data, metadata: response.metadata };
        } catch (error) { return this._throw(error, 'Failed to download export'); }
    }
    async exportEntity(type, format = 'json', idempotencyKey) {
        return this._wrap(() => this.api.exportEntity(type, format, idempotencyKey), 'Export failed');
    }
    async _wrap(fn, fallback) {
        try {
            const response = await fn();
            if (response && typeof response === 'object' && Object.hasOwn(response, 'success')) return response;
            return { success: true, data: response };
        } catch (error) { return this._throw(error, fallback); }
    }
    _throw(error, fallback) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || fallback, 500, 'UNKNOWN_ERROR', error);
    }
}
